import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    translations: {
        az: {},
        en: {},
        ru: {}
    }
}

const translationSlice = createSlice({
    name: 'translation',
    initialState,
    reducers: {
        init(state, action) {
            state.translations = action.payload;
        }
    }
});

export const { init } = translationSlice.actions

export default translationSlice.reducer;
